import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomDataset,
  BackendMutationArchiveCustomDatasetArgs,
} from 'src/types/backend';

import { CUSTOM_DATASET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ArchiveCustomModel($id: ID!) {
    archiveCustomDataset(id: $id) {
      ...CustomDataset
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

type Variables = BackendMutationArchiveCustomDatasetArgs;
type Result = BackendCustomDataset;

export const archiveCustomModel = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
